// Parent view of a child's rattrapage schedule: child selector + reused student page.
import React, { useState } from 'react';
import RattrapageSchedulePage from '@/features/student/pages/RattrapageSchedulePage';
import { ChildSelector } from '../components/ChildSelector';

const ParentRattrapageSchedulePage: React.FC = () => {
  const [childId, setChildId] = useState<string | null>(null);

  return (
    <div>
      <div className="px-6 pt-6">
        <ChildSelector onChildChange={setChildId} />
      </div>
      {childId && <RattrapageSchedulePage key={childId} studentId={childId} />}
    </div>
  );
};

export default ParentRattrapageSchedulePage;
